import { jsxs, jsx } from "react/jsx-runtime";
const IconCareerActiveSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1Zm5.459 6.198-3.01 6.99a.5.5 0 0 1-.261.26l-6.99 3.011a.499.499 0 0 1-.656-.658l3.034-6.966a.493.493 0 0 1 .259-.259l6.966-3.034a.501.501 0 0 1 .658.656Z" }),
      /* @__PURE__ */ jsx("path", { d: "M13 12.002a.993.993 0 0 1-.077.38.998.998 0 0 1-.24.341.994.994 0 0 1-1.066.2 1 1 0 0 1-.34-.241.998.998 0 0 1-.2-.3.996.996 0 0 1-.075-.373v-.015c0-.134.027-.26.075-.377a1 1 0 0 1 .25-.347c.09-.081.185-.15.29-.193a.994.994 0 0 1 .766 0 1 1 0 0 1 .346.249 1 1 0 0 1 .194.291A.996.996 0 0 1 13 12v.002Z" })
    ]
  }
);
export {
  IconCareerActiveSvg
};
